export default __webpack_public_path__ + "static/media/1-2.42566b2c.jpg";